import { ThunkDispatch, AnyAction } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';
import { showWarningAsync } from 'notification/store/thunks';
import { ShareUsersSetAction, setShareUsers } from './actions';
import { buildLoggerForStore } from 'logging/writers/utils';
import { getShareUsersRequestKey } from 'app/ShareUsersService';
import { selectRequestIsPending } from 'requestProgress/store/selectors';

export type LoadShareUsersAsyncThunk = (
    dispatch: ThunkDispatch<AnyAction>,
    _getState: () => State,
    { shareUsersService, loggingService }: Services
) => Promise<void>;

export const loadShareUsersAsync: () => LoadShareUsersAsyncThunk =
    () =>
    async (
        dispatch: ThunkDispatch<ShareUsersSetAction>,
        getState: () => State,
        { shareUsersService, loggingService }: Services
    ) => {
        const log = buildLoggerForStore('loadShareUsers');

        const loadShareUsersPending = selectRequestIsPending(
            getState(),
            getShareUsersRequestKey
        );

        if (!loadShareUsersPending) {
            log(loggingService, 'No need to load share users again');
            return;
        }

        log(loggingService, 'Loading share users');
        try {
            const users = await shareUsersService.getShareUsers();
            dispatch(setShareUsers(users));
        } catch (err) {
            dispatch(showWarningAsync('Error loading share users'));
        }
    };
